<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-11.5 780.5 24 24">
    <path
      d="M8.76,782.5l-0.04,0c0.57-0.01,1.03,0.13,1.34,0.44l0,0l0,0c1.11,1.11,0.07,4.08-2.42,7.59l-0.01-0.05
	c0.1,0.47,0.15,0.96,0.15,1.46c0,2.01-0.81,3.83-2.13,5.14l0,0c-1.32,1.31-3.13,2.13-5.14,2.13c-0.45,0-0.88-0.04-1.26-0.11
	l-0.07,0.05c-3.75,2.82-7.04,4.08-8.23,2.9h0c-1.13-1.15-0.01-4.25,2.64-7.88l0.01,0.05c-0.24-0.72-0.37-1.49-0.37-2.28
	c0-2.01,0.81-3.82,2.13-5.14l0,0c1.32-1.31,3.13-2.13,5.14-2.13c0.85,0,1.67,0.15,2.38,0.4l0.05-0.04
	C5.25,783.45,7.33,782.52,8.76,782.5L8.76,782.5z M7.22,783.63H7.19c-0.88,0.05-2.19,0.64-3.75,1.66l0.05,0.02
	c0.81,0.36,1.54,0.87,2.16,1.49h0c0.44,0.44,0.82,0.94,1.15,1.52l0.01-0.01c1.35-2.11,1.89-3.78,1.26-4.41l0,0
	C7.87,783.7,7.57,783.61,7.22,783.63L7.22,783.63z M-6.25,794.77c-1.78,2.53-2.57,4.58-1.86,5.3l0,0c0.7,0.69,2.66-0.03,5.12-1.73
	l-0.04-0.02c-0.6-0.33-1.15-0.74-1.63-1.22l0,0c-0.66-0.66-1.19-1.44-1.58-2.36L-6.25,794.77z" />
  </svg>
</template>
